import { Color } from '../types/color';

export function commonThemeBackgroundClass(color: Color): string {
  return commonThemeClass('background', color);
}

export function commonThemeColorClass(color: Color): string {
  return commonThemeClass('color', color);
}

export function getContrastColor(color: Color): Color {
  switch (color) {
    case 'background':
      return 'foreground';
    default:
      return 'background';
  }
}

function commonThemeClass(property: 'background' | 'color', color: Color): string {
  return `theme-${property}-${color}`;
}
